module.exports = __webpack_public_path__ + "repair1.34da8131.png";